import LoadListListItemProductDetail from './LoadListListItemProductDetail';


export default function LoadListListItemProduct(props){
    //console.debug("RTS Break LoadListListItemProduct");

    // if(props.data.product.specsDoc!=null){
    //     return (
    //         <Link target="_blank" rel="nooperner" href={props.data.product.specsDoc} sx={{textDecoration:'none', cursor:'pointer'}}>
    //             <LoadListListItemProductDetail data={props.data} />
    //         </Link>
    //     )
    // }
    // else{
        return (
            <LoadListListItemProductDetail data={props.data} />
        ) 
    // }   
}

